const releaseSettings = {
    eShopVersion: "2026.7.1",
    internalBuild: false,           // internal build is non-optimized version with tons of files generated
    saveXml: true,                  //disable this option when coding export, xml files won't be saved on the machine when debugging/testing
    hideLanguageSelector: false,    // set this to false when releasing a beta version to the public when translations are not ready
    polishPlaceholders: true,       // when releasing to production set it to true, this flag is responsible for displaying polish text instead of variable names
    hideOpacityPicker: false,        // color picker alpha slider should be hidden in next release
}

export default releaseSettings;